<template>
  <v-dialog v-model="dialog" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="primary"
        dark
        v-bind="attrs"
        v-on="on"
      >
        購読情報を追加する
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">購読情報検索</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col
              cols="12"
              md="6"
              sm="6"
            >
              <v-text-field
                label="購読情報検索"
                prepend-inner-icon="mdi-magnify"
                v-model="params.search"
                @change="getSubscriptions"
              >
              </v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
              sm="6"
              class="text-right"
            >
              <v-btn color="blue darken-1" text @click="dialog = false">キャンセル</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-data-table
                :headers="headers"
                :items="items"
                :server-items-length="item_total"
                :loading="loading"
                :options.sync="options"
                :footer-props="footer_props"
                disable-sort
                disable-filtering
                locale="ja-jp"
                loading-text="読込中"
                no-data-text="データがありません。"
                @update:options="getSubscriptions"
              >
        <template v-slot:item.web_accounts="{ item }">
          <span v-if="item.webaccount_max_count">
            {{ item.webaccount_count }}/{{ item.webaccount_max_count }}
          </span>
        </template>
              <template v-slot:item.action="{ item }">
                <v-btn
                  small
                  class="title-btn red white--text"
                  @click="setSubscription(item)"
                >
                  追加する
                </v-btn>
              </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">キャンセル</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      items: [],
      params: {
        search: '',
      },
      loading: false,
      item_total: 0,
      options: {
        itemsPerPage: 20,
      },
      footer_props: {
        'items-per-page-options': [],
        'items-per-page-text': null,
        'disable-items-per-page': true,
      },
      headers: [
        {text: "顧客コード", value: "client.cd"},
        {text: "顧客名称", value: "client.name_combined"},
        {text: "電話番号", value: "client.tel"},
        {text: "商品", value: "productdetail.name"},
        {text: "部数", value: "sum_amount"},
        {text: "ステータス", value: "status.name"},
        {text: `WEBアカウント`, value: "web_accounts"},
        {text: "操作", value: "action", width: "130px"},
      ],
    }
  },
  methods: {
    setSubscription(item) {
      this.dialog = false;
      this.$emit('select', item);
    },
    async getSubscriptions() {
      this.loading = true;
      try {
        this.params.page = this.options.page;
        let response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/subscriptions/`,
          {
            params: this.params,
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        this.item_total = response.data.count
        this.items = response.data.results
        this.loading = false;
      } catch(error) {
        // TODO エラーメッセージ
        console.log(error)
        this.loading = false;
      }
    }
  }
}
</script>